import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-product_but",
  "use": "icon-product_but-usage",
  "viewBox": "0 0 124 49",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 124 49\" id=\"icon-product_but\"><defs><style>#icon-product_but .a{fill:#ff6c00;}#icon-product_but .b{fill:#fff;font-size:21px;font-family:PingFang SC Medium, PingFang SC;letter-spacing:0.03em;}</style></defs><g transform=\"translate(-586 -625)\"><rect class=\"a\" width=\"124\" height=\"49\" rx=\"24\" transform=\"translate(586 625)\" /><text class=\"b\" transform=\"translate(605 657)\"><tspan x=\"0\" y=\"0\">立即展业</tspan></text></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol